export const PolicyRaterType = {
  AGE_RANGE: "age-range",
  FAMILY_FLOATER: "family-floater",
  PER_MILLE: "per-mille",
};
